import { Checkbox } from 'antd';
import styled from 'styled-components';
export const CheckBold = styled(Checkbox) `
  &&& {
    font-weight: bold;
    margin: 0.5rem;
    margin-left: 1rem;
  }
`;
export const GroupsContainer = styled.div `
  &&& {
    max-height: 8rem;
    overflow: hidden;
    overflow-y: auto;
  }
`;
export const CheckGroup = styled(Checkbox.Group) `
  &&& {
    display: grid;
    min-height: auto;
    max-height: 15rem;
    overflow: hidden;
    overflow-y: auto;

    .ant-checkbox-group-item {
      padding: 0.5rem;
      padding-left: 1rem;
      :hover {
        background-color: #e6f6ff;
      }
    }
  }
`;
